import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/api';

export default function LoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    // Normalise the email so stray autofill whitespace or capitalisation
    // (common on mobile keyboards) can't cause a false "invalid credentials".
    const cleanEmail = email.trim().toLowerCase();
    const { error } = await supabase.auth.signInWithPassword({ email: cleanEmail, password });
    setLoading(false);
    if (error) {
      // Supabase returns the same generic message for a wrong password on a
      // real account. Guide members — especially those who signed up on the
      // website and never typed their password — straight to the reset flow.
      if (/invalid login credentials/i.test(error.message)) {
        setError("Email or password not recognised. If you signed up on our website, tap \u201CForgot password?\u201D below to set a password for the app.");
      } else {
        setError(error.message);
      }
    } else {
      nav('/');
    }
  }

  return (
    <div style={{ minHeight: '100dvh', background: '#1A1A1A', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      {/* Logo */}
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <div style={{ fontSize: '1.8rem', fontWeight: 400, color: '#fff', letterSpacing: '0.04em' }}>team <span style={{ fontWeight: 800 }}>breakthrough</span></div>
        <div style={{ color: '#FF6200', fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.18em', marginTop: 6 }}>BOX · BATH · CORSHAM</div>
        <div style={{ color: '#FF6200', fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.16em', marginTop: 10 }}>TRAIN · RECOVER · BREAKTHROUGH</div>
      </div>

      {/* Card */}
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 380 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: 20 }}>Member Login</h2>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck="false" />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading} style={{ marginTop: 8 }}>
            {loading ? 'Logging in…' : 'Log In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.9rem' }}>
          <a href="/#/forgot-password" style={{ color: '#FF6200', fontWeight: 600 }}>Forgot password?</a>
        </p>
        <p style={{ textAlign: 'center', marginTop: 12, fontSize: '0.9rem', color: '#666' }}>
          New member? <a href="/#/signup" style={{ color: '#FF6200', fontWeight: 600 }}>Create account</a>
        </p>
      </div>

      {/* Guests can explore the app without an account */}
      <p style={{ textAlign: 'center', marginTop: 24, fontSize: '0.9rem' }}>
        <Link to="/" style={{ color: '#fff', fontWeight: 600 }}>Just looking? Browse classes &amp; treatments →</Link>
      </p>
    </div>
  );
}
